import { Fragment } from 'react'
import { Helmet } from 'react-helmet'
import PageTitle from '@components/PageTitle'
import Layout from '@layout/Main'
import TableBilling from './TableBilling'

function BillingManagement() {
  return (
    <Fragment>
      <Helmet>
        <title>
          SQUIDS :: Manajemen Tagihan
        </title>
      </Helmet>
      <PageTitle>
        Manajemen Tagihan
      </PageTitle>
      <Layout>
        <TableBilling />
      </Layout>
    </Fragment>
  )
}

export default BillingManagement
